import { render, staticRenderFns } from "./addDigiMR.vue?vue&type=template&id=f0539d60"
import script from "./addDigiMR.vue?vue&type=script&lang=js"
export * from "./addDigiMR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports